import { combineReducers } from "redux";
import PropertyDescriptionReducer from "../AiMarketingHub/PropertyDescription/PropertyDescriptionReducer";
import EmailGenerationReducer from "../AiMarketingHub/EmailGeneration/EmailGenerationReducer";
import SocialMediaCaptionReducer from "../AiMarketingHub/SocialMediaCaption/SocialMediaCaptionReducer";
import HistoryReducer from "../AiMarketingHub/History/HistoryReducer";
import LoaderReducer from "../Loader/LoaderReducer";
import AimhLpReducer from "../AiMarketingHub/AimhLandingPage/AimhLpReducer";
import RewriteParagraphReducer from "../AiMarketingHub/RewriteParagraph/RewriteParagraphReducer";
import FlyersReducer from "../Flyers/FlyersReducer";
import AgentsBioReducer from "../AiMarketingHub/AgentsBio/AgentsBioReducer";

export default combineReducers({
    PropertyDescriptionReducer,
    EmailGenerationReducer,
    SocialMediaCaptionReducer,
    HistoryReducer,
    LoaderReducer,
    AimhLpReducer,
    RewriteParagraphReducer,
    FlyersReducer,
    AgentsBioReducer,
});
